import React from 'react';
import styled from 'styled-components';

const Button = styled.a`
  display: inline-block;
  padding: 14px 28px;
  font-size: 1.1rem;
  border-radius: 999px;
  background: #ff761a;
  color: #ffffff;
  font-family: 'Lobster', cursive;
  transition: transform 0.05s ease, opacity 0.2s ease;
  text-align: center;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px); }
`;

const OrderButtonDoorDash = () => (
  <Button href="https://order.online/store/-25039044/?pickup=true&hideModal=true&utm_source=gfo&rwg_token=AAiGsoa2ocPMPo1d0L6-x-yfGvWGSsoovzavjrsnTIjSlPXTmzp7wFK8NF1R1Q-U7QHVuS6KotmiRbB9TEshseUT2M5E2FZO5A%3D%3D" target="_blank" rel="noopener noreferrer">
    Order Delivery (DoorDash)
  </Button>
);

export default OrderButtonDoorDash;
